// javascript-obfuscator footchinko.min.js --output footchinko.min.js
export class GameConstants {

    public static VERSION = "1.2";
    public static ASSETS_DIRECTORY = "assets";
    public static DEVELOPMENT = false;
    public static SHOW_PHYSICS_BODIES = false;
    public static ALPHA_PHYSICS_BODIES = 1;
    public static VERBOSE = false;
    
    public static GAME_WIDTH = 768;
    public static GAME_HEIGHT = 1024;

    // sponsors
    public static MINIJUEGOS = "minijuegos.com";
    public static SPIL = "spilgames";
    public static GAMEPIX = "GamePix";
    public static KEYGAMES = "keygames";
    public static FAMOBI = "famobi";
    public static CLICKJOGOS  = "clickjogos";
    public static IDAY = "iDay";
    public static BOOSTERMEDIA  = "boostermedia";
    public static BUONGIORNO = "buongiorno";
    public static MYREALGAMES = "My Real GAMES";
    public static WUKI = "WuKi";
    public static ADMEEN = "Admeen";
    public static AZOMEE = "azomee";
    public static MYFOOTBALLGAMES = "MyFootballGames";
    public static YOOB = "yoob";
    public static HOLAVERSE = "holaverse";
    public static MARVEL_MEDIA = "Marvel Media";
    public static GAMEZOP = "gamezop";
    public static GAME_DISTRIBUTION = "game distribution";
    public static LAGGED = "lagged";
    public static FUNO = "funo";
    public static POKI = "poki";
    public static KAPOW = "kapow";
    public static LOGICIEL_EDUCATIF = "logiciel educatif";
    public static PLAYWORKS = "playworks";
    public static TUNNL = "tunnl";
    public static MOBIL8 = "mobil8";
    public static GOOGLE = "google";
    public static NONE = "none";
    public static SPONSOR = GameConstants.MOBIL8;

    // economia
    public static CREDITS_ACHIEVED_TROPHY = 1000;
    public static CREDITS_GOALS = 25;
    public static CREDITS_EXTRA_GOALS = 75;
    public static FREEZE_GOALKEEPER_PRICE = 1500;
    public static EXTRA_BALLS_PRICE = 2500;
    public static BALL_OF_FIRE_PRICE = 5750;
    public static VOODOO_PRICE: number = 7500;
    public static HIGH_DAILY_REWARD_CREDITS = 3000;
    public static MEDIUM_DAILY_REWARD_CREDITS = 1500;
    public static LOW_DAILY_REWARD_CREDITS = 500;

    // tipos de recompensa
    public static HIGH_CREDITS_REWARD = "high_credits_reward";
    public static MEDIUM_CREDITS_REWARD = "medium_credits_reward";
    public static LOW_CREDITS_REWARD = "low_credits_reward";
    public static FREEZE_GOALKEEPER_REWARD  = "freeze_goalkeeper_reward";
    public static THREE_EXTRA_BALLS_REWARD  = "3_extra_balls_reward";
    public static BALL_OF_FIRE_REWARD  = "ball_of_fire";
    public static VOODOO_REWARD  = "voodoo_reward";
    public static NOTHING_REWARD  = "nothing_reward";

    // idiomas
    public static ENGLISH = "en";
    public static LANGUAGE = GameConstants.ENGLISH;

    public static DEFAULT_PLAYER_TEAM_ID = 54;
    public static DEFAULT_ADVERSARY_TEAM_ID = 7;

    public static VICTORY   = "1";
    public static DRAW      = "X";
    public static DEFEAT    = "2";

    public static OCEANIA_CUP = "OCEANIA CUP";
    public static AFRICA_CUP = "AFRICA CUP";
    public static ASIAN_CUP = "ASIAN CUP";
    public static GOLD_CUP = "GOLD CUP";
    public static AMERICA_CUP = "AMERICA CUP";
    public static OLYMPIC_GAMES = "OLYMPIC GAMES";
    public static EUROCUP = "EURO CUP";
    public static CONFEDERATIONS_CUP = "CONFEDERATIONS CUP";
    public static WORLD_CUP = "WORLD CUP";

    public static FINAL_MATCH = "FINAL";
    public static SEMIFINAL_MATCH = "SEMIFINAL";
    public static QUARTERFINAL_MATCH = "QUARTERFINAL";
    public static ROUND_OF_16_MATCH = "ROUND OF 16";
    public static GROUP_STAGE_MATCH = "GROUP STAGE";
    public static QUALIFICATION = "QUALIFICATION";

    public static FREEZE_GOALKEEPER = "freeze goalkeeper";
    public static EXTRA_BALLS = "extra balls";
    public static BALL_OF_FIRE = "ball of fire";
    public static VOODOO = "voodoo";

    public static GOALKEEPER = "goalkeeper";
    public static ELECTRIC_GOALKEEPER = "e_goalkeeper";
    public static FROZEN_GOALKEEPER = "f_goalkeeper";
    public static DUCK = "duck";
    public static UPPER_SHOCK_ABSORBER  = "upper_shock_absorber";
    public static POSTS = "post";
    public static BALL = "ball";
    public static PEG = "peg";
    public static PEG_1 = "p_1";
    public static PEG_2 = "p_2";
    public static PEG_3 = "p_3";
    public static PEG_4 = "p_4";
    public static SOLID_PEG = "s_p";
    public static ELASTIC_PEG = "ep";
    public static ELASTIC_PEG_RIGHT = "e_p_r";
    public static ELASTIC_PEG_LEFT = "e_p_l";
    public static MIDFIELDER_PEG = "mid_peg";
    public static MIDFIELDER_PEG_RIGHT = "m_p_r";
    public static MIDFIELDER_PEG_LEFT = "m_p_l";
    public static MIDFIELDER_PEG_RIGHT_MOVING_VERTICALLY_1 = "m_p_r_v_1";
    public static MIDFIELDER_PEG_RIGHT_MOVING_VERTICALLY_2 = "m_p_r_v_2";
    public static MIDFIELDER_PEG_RIGHT_MOVING_HORIZONTALLY_1 = "m_p_r_h_1";
    public static MIDFIELDER_PEG_RIGHT_MOVING_HORIZONTALLY_2 = "m_p_r_h_2";
    public static FORWARD_PEG = "f_peg";
    public static FORWARD_PEG_PENALTY = "f_peg_P";
    public static FORWARD_PEG_RIGHT = "f_p_r";
    public static FORWARD_PEG_LEFT = "f_p_l";
    public static FORWARD_PEG_RIGHT_MOVING_VERTICALLY_1 = "f_p_r_v_1";
    public static FORWARD_PEG_RIGHT_MOVING_VERTICALLY_2 = "f_p_r_v_2";
    public static FORWARD_PEG_RIGHT_MOVING_HORIZONTALLY_1 = "f_p_r_h_1";
    public static FORWARD_PEG_RIGHT_MOVING_HORIZONTALLY_2  = "f_p_r_h_2";
    public static CACTUS_PEG = "c_p";
    public static STREAKER = "striker";
    public static PLANK = "plank";
    public static CACTUS_PLANK = "c_pl";
    public static SOLID_PLANK = "s_pl";
    public static BREAKABLE_PLANK_1 = "b_p_1";
    public static BREAKABLE_PLANK_2 = "b_p_2";
    public static BREAKABLE_PLANK_3 = "b_p_3";
    public static BREAKABLE_PLANK_4 = "b_p_4";
    public static BLADE = "blade";
    public static BLADE_CW = "b_cw";
    public static BLADE_CCW = "b_ccw";
    public static MOVING_PLATFORM_RIGHT = "m_pl_r";
    public static MOVING_PLATFORM_LEFT = "m_pl_l";
    public static EXTRA_BALL = "e_b";
    public static MAGIC_POTION = "m_p";
    public static DAILY_REWARD_ITEM = "d_r_i";

    public static GAME_STORAGE_DATA_KEY = "footchinko_data";
}
